import {Api, apiFetch} from "../_helpers/api";
import {createQueryParameters, to_url} from "../_helpers/utils";
import ResponseError from "../_data/models/ResponseError";
import User from "../_data/models/User";
declare const fetch;

const UsersRepository = {
    get: (id: number | string) => {
        if (!id)
            return null;
        let _id = null;
        if (typeof id === 'number')
            _id = id.toString();
        else if (typeof id === 'string')
            _id = id;

        return apiFetch(
            to_url(to_url(Api.apiBaseUrl, 'users', _id)))
            .then(
                response => {
                    return response.json();
                })
            .catch((error: ResponseError) => {
                console.log(error.message);
                return {
                    error: true,
                    response: null
                };
            });

    },
    getStylesById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/styles') + query)
            .then(response => {
                return response.json();
            });
    },
    getLikedStylesById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/liked_styles') + query)
            .then(response => {
                return response.json();
            });
    },
    getSpecialsById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/specials') + query)
            .then(response => {
                return response.json();
            });
    },
    getFollowingUsersById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/users_followed') + query)
            .then(response => {
                return response.json();
            });
    },
    getFollowingShopsById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/liked_salons') + query)
            .then(response => {
                return response.json();
            });
    },
    getFollowersById: (id: number = null, page: number = null, perPage: number = 10) => {
        const query = createQueryParameters({page: page, per_page: perPage,});
        return apiFetch(to_url(Api.apiBaseUrl, 'users/' + id + '/followers') + query)
            .then(response => {
                return response.json();
            });
    },
    toggleFollowUser: (id: number = null, follower_id: number = null, is_followed: boolean) => {
        let data = new FormData();
        data.append('user[follower_id]', '' + follower_id);
        return apiFetch(
            to_url(Api.apiBaseUrl, 'users', id, is_followed ? 'unfollow' : 'follow'),
            {
                method: is_followed ? 'DELETE' : 'PUT', body: data
            })
            .catch((error: ResponseError) => {
                console.log(error.message);
            });
    },
    toggleFollowShop: (id: number = null, follower_id: number = null, is_followed: boolean) => {
        let data = new FormData();
        data.append('salon[user_id]', '' + follower_id);
        return apiFetch(
            to_url(Api.apiBaseUrl, 'salons', id, is_followed ? 'unlike' : 'like'),
            {
                method: 'POST', body: data
            })
            .catch((error: ResponseError) => {
                console.log(error.message);
            });
    },
    //TODO: If have edit
    saveProfile: (profile: User) => {
        return fetch(to_url(Api.apiBaseUrl, 'users/' + profile.id), {
            credentials: "same-origin",
            method: 'PUT',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Cache': 'no-cache'
            },
            body: JSON.stringify({
                user: profile
            })
        }).then(response => {
            return response.json();
        }).catch((error: ResponseError) => {
            console.log(error.message);
        });
    }
};

export default UsersRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/userRepository.ts